import { render, staticRenderFns } from "./AppliedDocuments.vue?vue&type=template&id=a325257a"
import script from "./AppliedDocuments.vue?vue&type=script&lang=js"
export * from "./AppliedDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports